import { createContext } from "react";

const DadosContext = createContext();

export default DadosContext;
